import { render, staticRenderFns } from "./item-wrapper.vue?vue&type=template&id=f523274a&scoped=true"
import script from "./item-wrapper.vue?vue&type=script&lang=js"
export * from "./item-wrapper.vue?vue&type=script&lang=js"
import style0 from "./item-wrapper.vue?vue&type=style&index=0&id=f523274a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f523274a",
  null
  
)

export default component.exports